/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApiRef } from '@backstage/core-plugin-api';
import { AlertingResult } from '../../types/alerting';
import { Entity } from '@backstage/catalog-model';

export const alertingApiRef = createApiRef<AlertingApi>({
  id: 'plugin.metrics-alerting-insights.alerting.service',
});

export interface AlertingApi {
  retrieveAlertingInfo: (entity: Entity) => Promise<AlertingResult[]>;
}
